module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/link-orange-94399a4a771149a86dff67cb0a5bd5c2.svg";